import { FC } from 'react';

import SVGIcon from 'react-inlinesvg';

import IconBluesky from '@assets/svg/icon-bluesky.svg';
import IconFacebook from '@assets/svg/icon-facebook.svg';
import IconLinkedIn from '@assets/svg/icon-linkedin.svg';
import IconWebsite from '@assets/svg/icon-website.svg';
import IconX from '@assets/svg/icon-x.svg';
import { AppLink } from '@components';
import { composeClassName } from '@utilities';

import styles from './index.module.scss';

const socials = [
	{
		icon: IconWebsite,
		href: 'https://dmarcian.com/'
	},
	{
		icon: IconFacebook,
		href: 'https://www.facebook.com/dmarcian/'
	},
	{
		icon: IconX,
		href: 'https://x.com/dmarcian/'
	},
	{
		icon: IconLinkedIn,
		href: 'https://www.linkedin.com/company/dmarcian/'
	},
	{
		icon: IconBluesky,
		href: 'https://bsky.app/profile/dmarcian.com/',
		className: styles.iconBluesky
	}
];

type Props = {
	className?: string;
};

export const Socials: FC<Props> = ({ className = '' }) => (
	<ul className={composeClassName(styles.socials, className)}>
		{socials.map((item, index) => (
			<li key={index}>
				<AppLink type="external" href={item.href}>
					<SVGIcon src={item.icon} className={item.className} />
				</AppLink>
			</li>
		))}
	</ul>
);

export default Socials;
